module.exports = __webpack_public_path__ + "logo-cropped.svg?86be613f922c656baf6b42747ce15fe1";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/logo-cropped.svg
// module id = 289
// module chunks = 0